import { render, staticRenderFns } from "./SelectCategoryComponent.vue?vue&type=template&id=09203b62&scoped=true&"
import script from "./SelectCategoryComponent.vue?vue&type=script&lang=js&"
export * from "./SelectCategoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategoryComponent.vue?vue&type=style&index=0&id=09203b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09203b62",
  null
  
)

export default component.exports